import partition from 'lodash/partition';

import { NormalizedEvent } from '../events';
import { SessionEventName } from '../events/event-names';

export const isSetSessionEvent = (event: NormalizedEvent): boolean =>
  event.event === SessionEventName.SetSession;

export function sortEvents(events: NormalizedEvent[]): NormalizedEvent[] {
  const [sessionEvents, otherEvents] = partition(events, isSetSessionEvent);
  return [...sessionEvents, ...otherEvents];
}
